import { useSelector } from "react-redux"

// Single gate for every download/export/print surface. Default-true on purpose:
// roles that predate the flag have no canExport, and `permissions` is null
// until SET_PERMISSIONS lands. The web-e 403 is the backstop either way.
export const useCanExport = () =>
  useSelector((state) => state.rolePermission?.permissions?.canExport !== false)
